<template>
    <div class="page-container">
        <el-card class="card-top" shadow="hover">
            <div class="card-actions">
                <el-form :inline="true" :model="searchForm" size="small" @submit.native.prevent>
                    <el-form-item label="教练名称">
                        <el-select v-model="searchForm.coachId" placeholder="请选择教练" filterable clearable
                            style="width: 140px">
                            <el-option v-for="item in coachOptions" :key="item.id" :label="item.name"
                                :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="学员名称">
                        <el-input v-model="searchForm.userKeyword" placeholder="请输入学员名称" clearable />
                    </el-form-item>
                    <el-form-item label="时间段">
                        <el-select v-model="searchForm.timeSlotId" placeholder="请选择时间段" filterable clearable
                            style="width: 330px">
                            <el-option v-for="item in timeSlotOptions" :key="item.timeSlotId" :value="item.timeSlotId"
                                :label="`${item.notes} - ${item.coachName}`" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="车辆类型">
                        <el-select v-model="searchForm.vehicleType" placeholder="请选择车辆" filterable clearable
                            style="width: 180px">
                            <el-option v-for="item in vehicleOptions" :key="item.vehicleType"
                                :label="item.description || (item.brand + '-' + item.model + '-' + item.licensePlate)"
                                :value="item.vehicleType" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开始时间">
                        <el-date-picker v-model="searchForm.startDate" type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间" clearable style="width: 180px" />
                    </el-form-item>
                    <el-form-item label="结束时间">
                        <el-date-picker v-model="searchForm.endDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择结束时间" clearable style="width: 180px" />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleSearch">查询</el-button>
                        <el-button @click="handleReset">重置</el-button>
                        <el-button @click="handleExport" type="primary"  style="margin-left: 8px;">导出</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card class="card-table" shadow="hover">
            <el-table :data="orders" border stripe style="width: 100%;" size="small" height="500px">
                <!-- 这里根据实际接口返回字段调整表头 -->
                <el-table-column prop="userName" label="预约用户" align="center" />
                <el-table-column  label="用户照片" align="center" width="120">
                    <template slot-scope="scope">
                        <div class="photo-cell">
                          <el-image
                            v-if="scope.row.picURI"
                            :src="scope.row.picURI"
                            :preview-src-list="[scope.row.picURI]"
                            fit="cover"
                            class="table-photo"
                          />
                          <span v-else style="color: #ccc;">无</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="coachName" label="教练" align="center" />
                <el-table-column prop="coachPhone" label="手机" align="center" />
                <el-table-column prop="vehicleLicensePlate" label="车辆" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.vehicleLicensePlate }} - {{ scope.row.vehicleModel }} - {{ scope.row.vehicleType }}
                    </template>
                </el-table-column>
                <el-table-column prop="timeSlotName" label="时间段" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.startTime }} - {{ scope.row.endTime }}
                    </template>
                </el-table-column>
                <el-table-column prop="createdAt" label="创建时间" align="center">
                </el-table-column>
                <el-table-column prop="statusDisplayName" label="状态" align="center">

                </el-table-column>
                <!-- 其它字段... -->
            </el-table>
            <div class="table-pagination">
                <el-pagination background layout="prev, pager, next" :total="total" :page-size="size"
                    :current-page="page" @current-change="handlePageChange" />
            </div>
        </el-card>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'OrderManage',
    data() {
        return {
            orders: [],
            total: 0,
            page: 1,
            size: 20,
            searchForm: {
                coachId: '',
                timeSlotId: '',
                userKeyword: '',
                vehicleType: '',
                startDate: '',
                endDate: ''
            },
            coachOptions: [],
            timeSlotOptions: [],
            vehicleOptions: []
        }
    },
    methods: {
        async fetchOrders() {
            try {
                const params = {
                    coachId: this.searchForm.coachId,
                    timeSlotId: this.searchForm.timeSlotId,
                    userKeyword: this.searchForm.userKeyword,
                    vehicleType: this.searchForm.vehicleType,
                    startDate: this.searchForm.startDate,
                    endDate: this.searchForm.endDate,
                    page: this.page,
                    size: this.size
                };
                const res = await axios.get('/api/appointments/renewal-records', { params });
                if (res.data && res.data.code && res.data.code !== 200) {
                    this.$message.error(res.data.message || '获取预约列表失败');
                    this.orders = [];
                    this.total = 0;
                } else {
                    this.orders = res.data.content || [];
                    this.total = res.data.totalElements || 0;
                }
            } catch (e) {
                this.$message.error((e.response && e.response.data && e.response.data.message) ? e.response.data.message : '获取预约列表失败');
            }
        },
        handleSearch() {
            this.page = 1;
            this.fetchOrders();
        },
        handleReset() {
            this.searchForm = {
                coachId: '',
                timeSlotId: '',
                userKeyword: '',
                vehicleType: '',
                startDate: '',
                endDate: ''
            };
            this.page = 1;
            this.fetchOrders();
        },
        handlePageChange(val) {
            this.page = val;
            this.fetchOrders();
        },
        handleExport() {
            const params = {
                coachId: this.searchForm.coachId,
                timeSlotId: this.searchForm.timeSlotId,
                userKeyword: this.searchForm.userKeyword,
                vehicleType: this.searchForm.vehicleType,
                startDate: this.searchForm.startDate,
                endDate: this.searchForm.endDate
            };
            const loading = this.$loading({
                lock: true,
                text: '正在导出，请稍候...',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.7)'
            });
            axios({
                url: '/api/appointments/renewal-records/export',
                method: 'get',
                params,
                responseType: 'blob'
            }).then(res => {
                const blob = new Blob([res.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = '预约导出数据.csv';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }).catch(() => {
                this.$message.error('导出失败');
            }).finally(() => {
                loading.close();
            });
        },
        async loadOptions() {
            // 获取教练列表
            try {
                const coachRes = await axios.get('/api/coaches', { params: { page: 1, size: 100 } });
                this.coachOptions = coachRes.data || [];
            } catch (e) {
                this.coachOptions = [];
            }
            // 获取时间段列表
            try {
                const slotRes = await axios.get('/api/time-slots/search/details/paged', { params: { page: 0, size: 100 } });
                this.timeSlotOptions = slotRes.data.content || [];
            } catch (e) {
                this.timeSlotOptions = [];
            }
            // 加载车辆列表
            try {
                const res = await axios.get('/api/vehicles', { params: { page: 1, size: 1000 } });
                this.vehicleOptions = res.data || [];
            } catch (e) {
                this.vehicleOptions = [];
            }
        }
    },
    mounted() {
        this.loadOptions();
        // 检查路由参数，如果有timeSlotId则回显到查询条件
        if (this.$route.query.timeSlotId) {
            this.searchForm.timeSlotId = ~~this.$route.query.timeSlotId;
        }
        this.handleSearch();
    }
}
</script>

<style lang="scss" scoped>
.page-container {
    padding: 24px 18px 0 18px;
    background: #f6f8fa;
    min-height: 100%;
}

.card-top {
    margin-bottom: 18px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.card-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.card-table {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.el-table {
    font-size: 15px;
    border-radius: 6px;
    overflow: hidden;
}

.table-pagination {
    margin-top: 18px;
    text-align: right;
}

.photo-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.table-photo {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  display: block;
  cursor: zoom-in;
}
</style>